export default __webpack_public_path__ + "static/media/NotPinging.1daec8e5.svg";